export const BUSINESS = {
  name: 'Alpha Auto Center',
  nameKo: '알파자동차정비',
  phone: '+14085788875',
  phoneFormatted: '(408) 578-8875',
  address: {
    street: '463 Blossom Hill Rd #G3',
    city: 'San Jose',
    state: 'CA',
    zip: '95123',
    full: '463 Blossom Hill Rd #G3, San Jose, CA 95123',
  },
  hours: {
    weekdays: 'Mon–Fri: 8AM – 5PM',
    saturday: 'Sat: 8AM – 4PM',
    sunday: 'Sun: Closed',
  },
  email: null,
  website: 'https://alphaautocenter.com',
  googleMapsUrl: 'https://maps.app.goo.gl/ZJugMj42j4xeG6qq9',
  yelpUrl: 'https://www.yelp.com/biz/alpha-auto-center-san-jose',
  rating: '4.9',
  reviewCount: '30',
  yearEstablished: 1990,
  tagline: "San Jose's Trusted Korean Auto Repair — Full Service Mechanic Shop",
  owner: 'Sean',
  languages: ['English', 'Korean'],
}
